import accounts from './accountActions';
import admin from './adminActions';
import apps from './appActions';
import clientPlugins from './clientPluginsActions';
import communication from './communicationActions';
import configs from './configActions';
import connectivity from './connectivityActions';
import conversion from './conversionActions';
import daylight from './daylightActions';
import groups from './groupsActions';
import instances from './instanceActions';
import meta from './metaActions';
import missionControl from './missionControlActions';
import muteReasons from './muteReasonActions';
import notes from './notesActions';
import offerings from './offeringsActions';
import partnerFunctions from './partnerFunctionActions';
import partner from './partnerActions';
import pims from './pimsActions';
import practice from './practiceActions';
import practiceAlerts from './practiceAlertsActions';
import practiceWorkflow from './practiceWorkflowActions';
import relations from './relationsActions';
import roles from './roleActions';
import tags from './tagsActions';
import toggle from './toggleActions';
import users from './usersActions';
import view from './viewActions';

const configureActions = (services) => {
    return {
        accounts: accounts(services),
        admin: admin(services),
        apps: apps(services),
        clientPlugins: clientPlugins(services),
        communication: communication(services),
        configs: configs(services),
        connectivity: connectivity(services),
        conversions: conversion(services),
        daylight: daylight(services),
        groups: groups(services),
        instances: instances(services),
        meta: meta(services),
        missionControl: missionControl(services),
        muteReasons: muteReasons(services),
        notes: notes(services),
        offerings: offerings(services),
        partnerFunctions: partnerFunctions(services),
        partner: partner(services),
        pims: pims(services),
        practice: practice(services),
        practiceAlerts: practiceAlerts(services),
        practiceWorkflow: practiceWorkflow(services),
        relations: relations(services),
        roles: roles(services),
        tags: tags(services),
        toggle: toggle(services),
        users: users(services),
        view: view(services),
    };
};

export default configureActions;
